<template>
  <v-form v-model="form_valido" ref="form" lazy-validation>
    <z-dialogo ref="dialogo" titulo="Agendamento Produto" :dividers="true" largura="600px" altura="300px" scrollable persistent>

      <template #prepend>
        <div class="py-2 px-4">
            <v-card flat color="grey lighten-4" class="rounded-lg">
              <v-card-text class="text-primary" style="border: 1px solid #ccc;">
                <div class="d-flex justify-space-between">
                  <span class="font-weight-bold">Referência:</span>
                  <span>{{ produto?.referencia }}</span>
                </div>
                <div class="d-flex justify-space-between">
                  <span class="font-weight-bold">Descrição:</span>
                  <span class="font-weight-bold">{{ produto?.descricao }}</span>
                </div>
                <div class="d-flex justify-space-between">
                  <span class="font-weight-bold">Estoque Atual:</span>
                  <span>{{ produto?.estoque }} {{ produto?.unidade }}</span>
                </div>
                <div class="d-flex justify-space-between">
                  <span class="font-weight-bold">Total Agendado:</span>
                  <span>{{ quantidadeTotalAgendada }} {{ produto?.unidade }}</span>
                </div>
              </v-card-text>
            </v-card>
        </div class="pa-4">
      </template>

      <template #conteudo>

        
        <v-row dense>
          <v-col cols="12" sm="12">

            <v-data-table
              :headers="headers"
              :items="produto.agendamento"
              disable-pagination
              hide-default-footer
              disable-sort
              dense
            >

              <template #item.data_agendamento="{ item }">
                {{ item.data_agendamento | dataBR }}
              </template>

              <template #item.quantidade="{ item }">
                {{ item.quantidade }} {{ produto?.unidade }}
              </template>

            </v-data-table>
          </v-col>
        </v-row>

      </template>
      
      <template #actions_right>
        <v-btn text @click="$refs.dialogo.fechar()" :disabled="salvando">
          Fechar
        </v-btn>
      </template>
    </z-dialogo>


  </v-form>
</template>

<script setup>
import { ref, computed, getCurrentInstance, onMounted, inject } from 'vue';
import queryBuilder from '@/app/helpers/QueryBuilder';

const { proxy } = getCurrentInstance();
const $store = proxy.$store;

const dialogo = ref(null);
const form = ref(null);
const form_valido = ref(true);
const salvando = ref(false);

const produto = ref({});

const headers = [
  { text: 'Data do Agendamento', value: 'data_agendamento' },
  { text: 'Quantidade', value: 'quantidade', align: 'end' },
];

const rules = {
  obrigatorio: [
    v => !!v || 'Campo obrigatório.',
  ],
  quantidade: [
    v => !!v || 'Quantidade é obrigatória.',
    v => (v > 0) || 'Quantidade deve ser maior que zero.',
  ],
};

const quantidadeTotalAgendada = computed(() => {
  return produto.value.agendamento?.reduce((total, agendamento) => total + Number(agendamento.quantidade || 0), 0) || 0;
});

function abrir(item) {
  produto.value = item;
  dialogo.value.abrir();
}

function fechar() {
  onFechar();
  dialogo.value.fechar();
}

defineExpose({
  abrir,
  fechar,
});

</script>

<style lang="scss" scoped>

</style>